<template>
  <VideosTab
    :product="COPPER.slug"
    @toggle-view-more="toggleViewMore"
    @play-video="$emit('play-video', $event)"
  />
</template>

<script lang="ts" setup>
import { useSeo } from '~/composables/useSeo'
import VideosTab from '~/components/market-insights/VideosTab.vue'
import { COPPER } from '~/constants/services/constants'

const isViewMoreActive = useState('isViewMoreActive')

definePageMeta({ scrollToTop: false })
defineEmits<{ 'play-video': [value: string] }>()

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: 'Copper Market Insight Videos',
  description:
    'Benchmark provides in-depth video content on Copper market developments, offering analysis, supply chain insights, and exclusive interviews.',
})

const toggleViewMore = (isActive: boolean) => {
  isViewMoreActive.value = isActive
}
useHead(seo)
</script>
